import React, { useEffect, useCallback, useMemo, useState, useRef } from "react";
// @material-ui/core components
import {
  Box,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/moment";
import moment from "moment";
import { useSelector } from "react-redux";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
// import Table from "../../components/Table/Table.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";

import CustomInput from "../../components/CustomInput/CustomInput";
import People from "@material-ui/icons/People";
import _ from "lodash";
import axios from "axios";
import { GetAllAccountsAPI, GetAllAccountsWithLightweightAPI, GetDebtorsListAPI, GetCreditorsListAPI, GetLedgerPartySummaryAPI } from "../../config/api";
import Button from "../../components/CustomButtons/Button.js";
import { exportToCSV, formatCurrency, formatDateForCSV } from "../../utils/exportUtils";
import PointToPointChallan from "./PointToPointChallan";
import RoundOffChallan from "./RoundOffChallan";
import PointToPointBill from "./PointToPointBill";
import RoundOffBill from "./RoundOffBill";
import LedgerList from "./LedgerList";
import RoundOff from "./RoundOff";
import PointToPoint from "./PointToPoint";
import Ledger from "./Ledger";
import { toast } from "react-toastify";
import { Search } from "@material-ui/icons";
import { generateP2PChallansForCompanies } from "../../utils/bulkChallanGenerator";
import { generateLedgersForCompanies } from "../../utils/bulkLedgerGenerator";
import { downloadGeneratedBillsForCompanies } from "../../utils/bulkBillPrintDownloader";
import { Autocomplete } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));
const columns = [
  // { id: "name", label: "Name" },
  { id: "accountCode", label: "Account Code" },
  { id: "name", label: "Account Name" },
  // { id: "telephoneOffice", label: "Telephone Office" },
  { id: "city", label: "City" },
  // { id: "state", label: "State" },       
  // { id: "status", label: "Status" },
  { id: "action", label: "Action" },
];
export default function AccountingList() {
  const classes = useStyles();
  const authToken = useSelector((state) => state.userReducer.authToken);

  const [accounts, setAccounts] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [selectedItem, setSelectedItem] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [tota, setTota] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openPointToPointChallanDialog, setOpenPointToPointChallanDialog] =
    useState(false);
  const [openPointToPointBillDialog, setOpenPointToPointBillDialog] =
    useState(false);
  const [openPTPTypeSelectionDialog, setOpenPTPTypeSelectionDialog] =
    useState(false);
  const [openRoundOffTypeSelectionDialog, setOpenRoundOffTypeSelectionDialog] =
    useState(false);
  const [openRoundOffDialog, setOpenRoundOffDialog] = useState(false);
  const [openRoundOffChallanDialog, setOpenRoundOffChallanDialog] =
    useState(false);
  const [openRoundOffBillDialog, setOpenRoundOffBillDialog] = useState(false);
  const [openLedgerDialog, setOpenLedgerDialog] = useState(false);
  const [openLedgerSelectionDialog, setOpenLedgerSelectionDialog] =
    useState(false);
  const [openBulkChallanDialog, setOpenBulkChallanDialog] = useState(false);
  const [selectedAccs, setSelectedAccs] = useState([]);
  const [bulkCompanyNames, setBulkCompanyNames] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [bulkModalSearchTerm, setBulkModalSearchTerm] = useState("");
  const [bulkModalAccounts, setBulkModalAccounts] = useState([]);
  const [bulkModalLoading, setBulkModalLoading] = useState(false);
  const bulkSearchTimeoutRef = useRef(null);
  const [bulkChallanMode, setBulkChallanMode] = useState("manual"); // manual | preselected

  const [openBulkLedgerDialog, setOpenBulkLedgerDialog] = useState(false);
  const [selectedLedgerAccs, setSelectedLedgerAccs] = useState([]);
  const [isGeneratingLedger, setIsGeneratingLedger] = useState(false);
  const [autoSelectBulkMarked, setAutoSelectBulkMarked] = useState(false);
  const [bulkLedgerDownloadMode, setBulkLedgerDownloadMode] = useState("manual"); // manual | preselected

  const [openBulkBillPrintDialog, setOpenBulkBillPrintDialog] = useState(false);
  const [selectedBillPrintAccs, setSelectedBillPrintAccs] = useState([]);
  const [isDownloadingBills, setIsDownloadingBills] = useState(false);
  const [bulkBillPrintMode, setBulkBillPrintMode] = useState("manual"); // manual | preselected

  const bulkPrintEligibleAccounts = useMemo(() => {
    // Use a single canonical field everywhere: `printBulk`.
    // Keep backward compatibility for older data shapes by normalizing at read time.
    const isTrue = (v) => v === true || v === "true" || v === 1 || v === "1";
    return (bulkModalAccounts || []).filter((acc) => {
      const flag = acc?.printBulk ?? acc?.printbulk; // handle legacy lowercase field
      return isTrue(flag);
    });
  }, [bulkModalAccounts]);

  const bulkPrintEligibleNames = useMemo(
    () =>
      bulkPrintEligibleAccounts
        .map((acc) => acc.name || acc.accountName || "")
        .filter(Boolean),
    [bulkPrintEligibleAccounts]
  );

  const allCompanyNames = useMemo(
    () =>
      (bulkModalAccounts || [])
        .map((acc) => acc.name || acc.accountName || "")
        .filter(Boolean),
    [bulkModalAccounts]
  );

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bulkPackingCharge, setBulkPackingCharge] = useState("");

  const [PTPType, setPTPType] = useState("challan");
  const [ledgerType, setLedgerType] = useState("Challan");
  let userInfo = useSelector((state) => state.userReducer.userInfo);

  // State for Debtors and Creditors export
  const [isExportingDebtors, setIsExportingDebtors] = useState(false);
  const [isExportingCreditors, setIsExportingCreditors] = useState(false);
  const [exportStartDate, setExportStartDate] = useState(null);
  const [exportEndDate, setExportEndDate] = useState(null);
  const [openExportDateDialog, setOpenExportDateDialog] = useState(false);
  const [exportMode, setExportMode] = useState(null); // "debtors" | "creditors"

  // async function _getAccounts() {
  //   try {
  //     let res = await axios.get(GetAllAccountsAPI(userInfo.entity), {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });
  //     setAccounts(res.data.accounts);
  //   } catch (err) {
  //     // toast.error(('Cannot fetch data'), {
  //     //   position: "top-center",
  //     //   autoClose: 1500,
  //     //   hideProgressBar: false,
  //     //   closeOnClick: true,
  //     //   pauseOnHover: true,
  //     //   draggable: true,
  //     //   progress: undefined,
  //     //   theme: "light",
  //     // });  
  //   }
  // }

  const _getAccounts = useCallback(async (pageNum, rowsPerPageNum, searchValue = "") => {
    setLoading(true);
    try {
      let query = "";

      // If searching, use server-side search with pagination
      if (searchValue && searchValue.trim() !== "") {
        const skipNum = pageNum * rowsPerPageNum;
        query = `&search=${encodeURIComponent(searchValue.trim())}&limit=${rowsPerPageNum}&skip=${skipNum}&view=aclist`;
      } else {
        // Normal pagination when not searching
        const skipNum = pageNum * rowsPerPageNum;
        query = `&limit=${rowsPerPageNum}&skip=${skipNum}&view=aclist`;
      }

      let res = await axios.get(
        GetAllAccountsWithLightweightAPI(userInfo.entity) + query,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // Sort accounts alphabetically by name
      const sortedAccounts = (res.data.accounts || []).sort((a, b) => {
        const nameA = (a.name || '').toLowerCase();
        const nameB = (b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
      setAccounts(sortedAccounts);
      setTota(res.data.total || 0);

    } catch (err) {
      toast.error("Failed to load accounts. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    } finally {
      setLoading(false);
    }

  }, [authToken, userInfo.entity])

  const hasInitialLoad = useRef(false);

  // Debounced search effect
  useEffect(() => {
    if (!hasInitialLoad.current) return; // Skip on initial mount

    const debounceTimer = setTimeout(() => {
      setSearchTerm(search);
      setPage(0); // Reset to first page on new search
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [search]);

  // Initial load and pagination
  useEffect(() => {
    if (!hasInitialLoad.current) {
      hasInitialLoad.current = true;
      _getAccounts(page, rowsPerPage, searchTerm);
    } else {
      _getAccounts(page, rowsPerPage, searchTerm);
    }
  }, [page, rowsPerPage, searchTerm, _getAccounts]);

  // Refresh when dialogs close
  useEffect(() => {
    if (!openRoundOffChallanDialog && !openLedgerDialog && hasInitialLoad.current) {
      _getAccounts(page, rowsPerPage, searchTerm);
    }
  }, [openRoundOffChallanDialog, openLedgerDialog]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const RoundOffTypeSelectionDialog = () => {
    let types = [
      {
        label: "Challan",
        value: "challan",
      },
      {
        label: "Bill",
        value: "bill",
      },
    ];
    return (
      <Dialog
        onClose={() => setOpenRoundOffTypeSelectionDialog(false)}
        aria-labelledby="simple-dialog-title"
        open={openRoundOffTypeSelectionDialog}
      >
        <DialogTitle id="simple-dialog-title">Select Type</DialogTitle>
        <List>
          {types.map(({ label, value }) => (
            <ListItem
              button
              onClick={() => {
                if (value === "bill") {
                  setOpenRoundOffBillDialog(true);
                } else {
                  setOpenRoundOffChallanDialog(true);
                }
                setOpenRoundOffTypeSelectionDialog(false);
              }}
              key={value}
            >
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  };

  // No need for client-side filtering since we use server-side search
  let data = accounts;


  const handleSearch = () => {
    setSearchTerm(search);
    setPage(0); // Reset to first page on search
  };

  // Fetch accounts for bulk P2P challan modal with search support
  const _getBulkModalAccounts = useCallback(async (searchTerm = "") => {
    setBulkModalLoading(true);
    try {
      let url = GetAllAccountsWithLightweightAPI(userInfo.entity);
      if (searchTerm && searchTerm.trim() !== "") {
        url += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      let res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const isTrue = (v) => v === true || v === "true" || v === 1 || v === "1";
      // Sort accounts alphabetically by name
      const sortedAccounts = (res.data.accounts || [])
        .map((acc) => {
          // Normalize legacy flags into canonical `printBulk`
          const normalizedPrintBulk = isTrue(acc?.printBulk) ? true : isTrue(acc?.printbulk);
          return { ...acc, printBulk: Boolean(normalizedPrintBulk) };
        })
        .sort((a, b) => {
          const nameA = (a.name || '').toLowerCase();
          const nameB = (b.name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
      setBulkModalAccounts(sortedAccounts);
    } catch (err) {
      toast.error("Failed to load accounts. Please try again.");
    } finally {
      setBulkModalLoading(false);
    }
  }, [authToken, userInfo.entity]);

  // Load accounts when bulk dialog opens
  useEffect(() => {
    if (openBulkChallanDialog) {
      setBulkModalSearchTerm("");
      _getBulkModalAccounts("");
      if (bulkChallanMode === "manual") setSelectedAccs([]);
    } else {
      // Cleanup when dialog closes
      if (bulkSearchTimeoutRef.current) {
        clearTimeout(bulkSearchTimeoutRef.current);
      }
      setBulkModalSearchTerm("");
      setSelectedAccs([]);
      setBulkModalAccounts([]);
      setBulkModalLoading(false);
    }
  }, [openBulkChallanDialog, _getBulkModalAccounts, bulkChallanMode]);

  // Load accounts when Bulk Ledger dialog opens (reuse same account list as Bulk P2P)
  useEffect(() => {
    if (openBulkLedgerDialog) {
      setSelectedLedgerAccs([]);
      _getBulkModalAccounts("");
    }
  }, [openBulkLedgerDialog, _getBulkModalAccounts]);

  // Load accounts when Bulk Bill Print dialog opens
  useEffect(() => {
    if (openBulkBillPrintDialog) {
      setBulkModalSearchTerm("");
      _getBulkModalAccounts("");
      // default to preselected when opened from the Marked button (set below), but keep manual behavior otherwise
    } else {
      setSelectedBillPrintAccs([]);
      setIsDownloadingBills(false);
    }
  }, [openBulkBillPrintDialog, _getBulkModalAccounts]);

  // Auto-select accounts marked for bulk print when requested
  useEffect(() => {
    if (!openBulkLedgerDialog || !autoSelectBulkMarked) return;
    if (!bulkPrintEligibleAccounts || bulkPrintEligibleAccounts.length === 0) return;

    setSelectedLedgerAccs(bulkPrintEligibleNames);
    setAutoSelectBulkMarked(false);
  }, [openBulkLedgerDialog, autoSelectBulkMarked, bulkPrintEligibleAccounts, bulkPrintEligibleNames]);

  // When user picks "Download all pre selected", auto-select marked accounts.
  useEffect(() => {
    if (!openBulkLedgerDialog) return;
    if (bulkLedgerDownloadMode !== "preselected") return;
    // Ensure we have the full list (not limited by a previous search)
    setBulkModalSearchTerm("");
    _getBulkModalAccounts("");
    setSelectedLedgerAccs(bulkPrintEligibleNames);
  }, [openBulkLedgerDialog, bulkLedgerDownloadMode, bulkPrintEligibleNames]);

  // When user picks "Generate pre selected" for Bulk Bill Print, populate with printBulk companies (but allow unselect).
  useEffect(() => {
    if (!openBulkBillPrintDialog) return;
    if (bulkBillPrintMode !== "preselected") return;
    setSelectedBillPrintAccs(bulkPrintEligibleNames);
  }, [openBulkBillPrintDialog, bulkBillPrintMode, bulkPrintEligibleNames]);

  // When user picks "Generate pre selected" for Bulk P2P Challan, populate with printBulk companies (but allow unselect).
  useEffect(() => {
    if (!openBulkChallanDialog) return;
    if (bulkChallanMode !== "preselected") return;
    setSelectedAccs(bulkPrintEligibleNames);
  }, [openBulkChallanDialog, bulkChallanMode, bulkPrintEligibleNames]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (bulkSearchTimeoutRef.current) {
        clearTimeout(bulkSearchTimeoutRef.current);
      }
    };
  }, []);

  // Bulk P2P Challan Generation - resolve selected names to account objects from modal so same API/query as row-click P2P
  const handleBulkChallanGenerate = async () => {
    if (selectedAccs.length === 0) {
      toast.error("Please select at least one company");
      return;
    }

    const accounts = selectedAccs
      .map((name) => bulkModalAccounts.find((acc) => (acc.name || acc.accountName || "") === name))
      .filter(Boolean);

    if (accounts.length === 0) {
      toast.error("Selected companies could not be resolved. Try reopening the bulk dialog.");
      return;
    }

    if (accounts.length < selectedAccs.length) {
      toast.warn(`${selectedAccs.length - accounts.length} selection(s) could not be resolved and were skipped.`);
    }

    setIsGenerating(true);
    toast.info(`Starting PDF generation for ${accounts.length} companies...`);

    try {
      const packingChargeNum = bulkPackingCharge !== "" && !Number.isNaN(Number(bulkPackingCharge)) ? Number(bulkPackingCharge) : 0;
      const result = await generateP2PChallansForCompanies(
        accounts,
        startDate,
        endDate,
        userInfo.entity,
        authToken,
        (progress) => {
          if (progress.status === "completed") {
            toast.success(`${progress.company}: Generated (${progress.index}/${progress.total})`);
          } else if (progress.status === "not_found") {
            toast.warn(`${progress.company}: Not found in database`);
          } else if (progress.status === "skipped") {
            toast.warn(`${progress.company}: ${progress.reason}`);
          } else if (progress.status === "error") {
            toast.error(`${progress.company}: ${progress.error}`);
          }
        },
        packingChargeNum > 0 ? packingChargeNum : undefined
      );

      toast.success(
        `Completed! Generated ${result.success} PDF(s), ${result.failed} not found`
      );

      if (result.notFound.length > 0) {
        toast.warn(`${result.notFound.length} companies not found: ${result.notFound.join(", ")}`);
      }

      setOpenBulkChallanDialog(false);
      setSelectedAccs([]);
    } catch (error) {
      toast.error(`Failed to generate PDFs: ${error.message || "Unknown error"}`);
    } finally {
      setIsGenerating(false);
    }
  };

  // Bulk Ledger Generation - resolve selected names from modal accounts (same pattern as Bulk P2P)
  const handleBulkLedgerGenerate = async () => {
    if (selectedLedgerAccs.length === 0) {
      toast.error("Please select at least one company");
      return;
    }

    const accounts = selectedLedgerAccs
      .map((name) => bulkModalAccounts.find((acc) => (acc.name || acc.accountName || "") === name))
      .filter(Boolean);

    if (accounts.length === 0) {
      toast.error("Selected companies could not be resolved. Try reopening the bulk dialog.");
      return;
    }

    if (accounts.length < selectedLedgerAccs.length) {
      toast.warn(`${selectedLedgerAccs.length - accounts.length} selection(s) could not be resolved and were skipped.`);
    }

    setIsGeneratingLedger(true);
    toast.info(`Starting ledger generation for ${accounts.length} companies...`);

    try {
      const result = await generateLedgersForCompanies(
        accounts,
        startDate,
        endDate,
        ledgerType,
        userInfo.entity,
        authToken,
        (progress) => {
          if (progress.status === "completed") {
            toast.success(`${progress.company}: Generated (${progress.index}/${progress.total})`);
          } else if (progress.status === "skipped") {
            toast.warn(`${progress.company}: ${progress.reason || "Skipped"}`);
          } else if (progress.status === "error") {
            toast.error(`${progress.company}: ${progress.error}`);
          }
        }
      );

      toast.success(`Completed! Generated ${result.success} ledger PDF(s).`);

      setOpenBulkLedgerDialog(false);
      setSelectedLedgerAccs([]);
    } catch (error) {
      toast.error(`Failed to generate ledger PDFs: ${error.message || "Unknown error"}`);
    } finally {
      setIsGeneratingLedger(false);
    }
  };

  const handleBulkBillPrintDownload = async () => {
    if (isDownloadingBills) return;
    if (!startDate || !endDate) {
      toast.error("Please select Start Date and End Date");
      return;
    }

    const selectedNames =
      bulkBillPrintMode === "preselected" ? selectedBillPrintAccs : selectedBillPrintAccs;

    if (!selectedNames || selectedNames.length === 0) {
      toast.error("Please select at least one company");
      return;
    }

    const eligibleAccounts = bulkPrintEligibleAccounts;
    const accountsToProcess = selectedNames
      .map((name) =>
        eligibleAccounts.find((acc) => (acc.name || acc.accountName || "") === name)
      )
      .filter(Boolean);

    if (accountsToProcess.length === 0) {
      toast.error("Selected companies could not be resolved. Try reopening the dialog.");
      return;
    }

    setIsDownloadingBills(true);
    toast.info(`Preparing one ZIP with bills for ${accountsToProcess.length} companies...`);

    try {
      const result = await downloadGeneratedBillsForCompanies(
        accountsToProcess,
        startDate,
        endDate,
        userInfo.entity,
        authToken,
        (progress) => {
          if (progress.status === "completed") {
            toast.success(
              `${progress.company}: Added to ZIP (${progress.index}/${progress.total})`
            );
          } else if (progress.status === "skipped") {
            toast.warn(
              `${progress.company}: ${progress.reason || "No bills found"}`
            );
          } else if (progress.status === "error") {
            toast.error(`${progress.company}: ${progress.error}`);
          }
        }
      );

      toast.success(`Done. Downloaded 1 ZIP. Added ${result.success} compan${result.success === 1 ? "y" : "ies"}. Skipped ${result.skipped}.`);
      setOpenBulkBillPrintDialog(false);
    } catch (error) {
      toast.error(`Failed: ${error.message || "Unknown error"}`);
    } finally {
      setIsDownloadingBills(false);
    }
  };

  // Export Debtors (Sales parties with running challan balance)
  const handleExportDebtors = async (start, end) => {
    setIsExportingDebtors(true);
    try {
      const isStartProvided = !!start;
      const isEndProvided = !!end;

      if (isStartProvided !== isEndProvided) {
        toast.error("Please select both Start Date and End Date for export.");
        setIsExportingDebtors(false);
        return;
      }

      // If both empty, export all-time by using a wide range.
      const exportStart = isStartProvided ? moment(start) : moment("01-01-1970", "DD-MM-YYYY", true);
      const exportEnd = isEndProvided ? moment(end) : moment();
      if (!exportStart.isValid() || !exportEnd.isValid() || exportStart.isAfter(exportEnd)) {
        toast.error("Invalid date range. Please check Start and End dates.");
        setIsExportingDebtors(false);
        return;
      }

      // Call backend party-summary endpoint (single request)
      const response = await axios.get(GetLedgerPartySummaryAPI(), {
        params: {
          entity: userInfo.entity,
          partyType: "debtor",
          startDate: exportStart.format("DD-MM-YYYY"),
          endDate: exportEnd.format("DD-MM-YYYY"),
          ledgerType: "Challan",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const rows = response.data.rows || [];

      if (rows.length === 0) {
        toast.warn("No debtors found to export for the selected period.");
        setIsExportingDebtors(false);
        return;
      }

      const periodLabel = `${exportStart.format("DD-MM-YYYY")} to ${exportEnd.format("DD-MM-YYYY")}`;

      // We don't export back balance separately; we export a single
      // "Amount" column = backBalance + currentBalance.
      let totalAmount = 0;

      const formattedData = [];

      // Header row with period info at the top of Excel
      formattedData.push({
        "#": "",
        "Company Name": `Period: ${periodLabel}`,
        "Amount": "",
      });

      // Blank spacer row
      formattedData.push({
        "#": "",
        "Company Name": "",
        "Amount": "",
      });

      rows.forEach((row, index) => {
        const backBalance = Number(row.backBalance || 0);
        const currentBalance = Number(row.currentBalance || 0);
        const amount = backBalance + currentBalance;
        totalAmount += amount;

        formattedData.push({
          "#": index + 1,
          "Company Name": row.companyName || "",
          "Amount": formatCurrency(amount || 0, 2),
        });
      });

      // Blank spacer before totals
      formattedData.push({
        "#": "",
        "Company Name": "",
        "Amount": "",
      });

      // Totals row
      formattedData.push({
        "#": "Total",
        "Company Name": "",
        "Amount": formatCurrency(totalAmount, 2),
      });

      const timestamp = moment().format("YYYY-MM-DD_HH-mm-ss");
      const fileName =
        `Debtors_Ledger_Summary_${exportStart.format("DD-MM-YYYY")}_${exportEnd.format("DD-MM-YYYY")}_${timestamp}.csv`;
      exportToCSV(
        formattedData,
        ["#", "Company Name", "Amount"],
        fileName
      );

      toast.success(`Exported ${rows.length} debtors successfully!`);
    } catch (error) {
      toast.error(`Failed to export debtors: ${error.message || "Unknown error"}`);
    } finally {
      setIsExportingDebtors(false);
    }
  };

  // Export Creditors (Purchase parties with running challan balance)
  const handleExportCreditors = async (start, end) => {
    setIsExportingCreditors(true);
    try {
      const isStartProvided = !!start;
      const isEndProvided = !!end;

      if (isStartProvided !== isEndProvided) {
        toast.error("Please select both Start Date and End Date for export.");
        setIsExportingCreditors(false);
        return;
      }

      // If both empty, export all-time by using a wide range.
      const exportStart = isStartProvided ? moment(start) : moment("01-01-1970", "DD-MM-YYYY", true);
      const exportEnd = isEndProvided ? moment(end) : moment();
      if (!exportStart.isValid() || !exportEnd.isValid() || exportStart.isAfter(exportEnd)) {
        toast.error("Invalid date range. Please check Start and End dates.");
        setIsExportingCreditors(false);
        return;
      }

      // Call backend party-summary endpoint (single request)
      const response = await axios.get(GetLedgerPartySummaryAPI(), {
        params: {
          entity: userInfo.entity,
          partyType: "creditor",
          startDate: exportStart.format("DD-MM-YYYY"),
          endDate: exportEnd.format("DD-MM-YYYY"),
          ledgerType: "Challan",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const rows = response.data.rows || [];

      if (rows.length === 0) {
        toast.warn("No creditors found to export for the selected period.");
        setIsExportingCreditors(false);
        return;
      }

      const periodLabel = `${exportStart.format("DD-MM-YYYY")} to ${exportEnd.format("DD-MM-YYYY")}`;

      // We don't export back balance separately; we export a single
      // "Amount" column = backBalance + currentBalance.
      let totalAmount = 0;

      const formattedData = [];

      // Header row with period info at the top of Excel
      formattedData.push({
        "#": "",
        "Company Name": `Period: ${periodLabel}`,
        "Amount": "",
      });

      // Blank spacer row
      formattedData.push({
        "#": "",
        "Company Name": "",
        "Amount": "",
      });

      rows.forEach((row, index) => {
        const backBalance = Number(row.backBalance || 0);
        const currentBalance = Number(row.currentBalance || 0);
        const amount = backBalance + currentBalance;
        totalAmount += amount;

        formattedData.push({
          "#": index + 1,
          "Company Name": row.companyName || "",
          "Amount": formatCurrency(amount || 0, 2),
        });
      });

      // Blank spacer before totals
      formattedData.push({
        "#": "",
        "Company Name": "",
        "Amount": "",
      });

      // Totals row
      formattedData.push({
        "#": "Total",
        "Company Name": "",
        "Amount": formatCurrency(totalAmount, 2),
      });

      const timestamp = moment().format("YYYY-MM-DD_HH-mm-ss");
      const fileName =
        `Creditors_Ledger_Summary_${exportStart.format("DD-MM-YYYY")}_${exportEnd.format("DD-MM-YYYY")}_${timestamp}.csv`;
      exportToCSV(
        formattedData,
        ["#", "Company Name", "Amount"],
        fileName
      );

      toast.success(`Exported ${rows.length} creditors successfully!`);
    } catch (error) {
      toast.error(`Failed to export creditors: ${error.message || "Unknown error"}`);
    } finally {
      setIsExportingCreditors(false);
    }
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <Grid container style={{ alignItems: "center" }}>
              <GridItem xs={12} sm={12} md={6}>
                <h4 className={classes.cardTitleWhite}>Accounts</h4>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Box display="flex" flexDirection="column" style={{ gap: "12px" }}>
                  {/* Search Bar */}
                  <CustomInput
                    id="search"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      style: {
                        color: "white",
                      },
                      placeholder: "Search",
                      value: search,
                      onChange: (e) => {
                        setSearch(e.target.value);
                      },
                      onKeyDown: (e) => {
                        if (e.keyCode === 13) {
                          e.preventDefault();
                          handleSearch();
                        }
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton color={"secondary"} onClick={handleSearch}>
                            <Search />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </GridItem>
            </Grid>
          </CardHeader>

          <CardBody>
            {/* Export & Bulk Buttons (below purple header, above table) */}
            <Box mb={2}>
              <Grid container spacing={1}>
                {/* <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setBulkChallanMode("manual");
                      setSelectedAccs([]);
                      setOpenBulkChallanDialog(true);
                    }}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    Bulk P2P Challan
                  </Button>
                </Grid> */}
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setBulkChallanMode("preselected");
                      setOpenBulkChallanDialog(true);
                    }}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    Bulk P2P Challan (Marked)
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => setOpenBulkLedgerDialog(true)}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    Bulk Ledger
                  </Button>
                </Grid>
                {/* <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setLedgerType("Challan");
                      setAutoSelectBulkMarked(true);
                      setOpenBulkLedgerDialog(true);
                    }}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    Bulk Ledger Print (Marked)
                  </Button>
                </Grid> */}
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setBulkBillPrintMode("preselected");
                      setOpenBulkBillPrintDialog(true);
                    }}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    Bulk Bill Print (Marked)
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setExportMode("debtors");
                      setOpenExportDateDialog(true);
                    }}
                    disabled={isExportingDebtors}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    {isExportingDebtors ? "Exporting..." : "Export Debtors"}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      setExportMode("creditors");
                      setOpenExportDateDialog(true);
                    }}
                    disabled={isExportingCreditors}
                    style={{ whiteSpace: "nowrap", width: "100%" }}
                    fullWidth
                  >
                    {isExportingCreditors ? "Exporting..." : "Export Creditors"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align="center"
                      padding={headCell.disablePadding ? 'none' : 'default'}
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={(event) => handleRequestSort(event, headCell.id)}
                        style={{
                          minWidth: headCell.minWidth,
                          maxWidth: headCell.maxWidth,
                          fontWeight: 'bold'
                        }}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                      <CircularProgress />
                      <Box style={{ color: "#666", marginTop: "16px" }}>
                        {searchTerm ? "Searching accounts..." : "Loading accounts..."}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                      <Box style={{ color: "#666" }}>
                        {searchTerm ? "No accounts found matching your search." : "No accounts found."}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  data.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row._id}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.id === "action") {
                            return (
                              <TableCell align={"center"} key={column.id}>
                                <Box display={"flex"} justifyContent={"center"} gap={1}>
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      setSelectedItem(row);
                                      setOpenPTPTypeSelectionDialog(true);
                                    }}
                                  >
                                    Point to point
                                  </Button>
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      setSelectedItem(row);
                                      setOpenRoundOffDialog(true);
                                    }}
                                  >
                                    Round Off
                                  </Button>
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      setSelectedItem(row);
                                      setOpenLedgerSelectionDialog(true);
                                    }}
                                  >
                                    Ledger
                                  </Button>
                                </Box>
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={tota}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardBody>
        </Card>
      </GridItem>
      {selectedItem && openPointToPointChallanDialog ? (
        <PointToPointChallan
          open={openPointToPointChallanDialog}
          item={selectedItem}
          close={() => setOpenPointToPointChallanDialog(false)}
          startDate={startDate}
          endDate={endDate}
        />
      ) : null}
      {selectedItem && openPointToPointBillDialog ? (
        <PointToPointBill
          open={openPointToPointBillDialog}
          item={selectedItem}
          close={() => setOpenPointToPointBillDialog(false)}
          startDate={startDate}
          endDate={endDate}
        />
      ) : null}
      {selectedItem && openRoundOffChallanDialog ? (
        <RoundOffChallan
          open={openRoundOffChallanDialog}
          item={selectedItem}
          close={() => setOpenRoundOffChallanDialog(false)}
          startDate={startDate}
          endDate={endDate}
        />
      ) : null}
      {selectedItem && openRoundOffBillDialog ? (
        <RoundOffBill
          open={openRoundOffBillDialog}
          item={selectedItem}
          close={() => setOpenRoundOffBillDialog(false)}
        />
      ) : null}
      {selectedItem && openLedgerDialog ? (
        <LedgerList
          open={openLedgerDialog}
          item={selectedItem}
          close={() => setOpenLedgerDialog(false)}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          ledgerType={ledgerType}
        />
      ) : null}
      {selectedItem && openRoundOffDialog ? (
        <RoundOff
          open={openRoundOffDialog}
          item={selectedItem}
          close={() => setOpenRoundOffDialog(false)}
          openRoundOffChallanDialog={openRoundOffChallanDialog}
          setOpenRoundOffChallanDialog={setOpenRoundOffChallanDialog}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      ) : null}
      {selectedItem && openPTPTypeSelectionDialog ? (
        <PointToPoint
          item={selectedItem}
          PTPType={PTPType}
          openPTPTypeSelectionDialog={openPTPTypeSelectionDialog}
          setOpenPTPTypeSelectionDialog={setOpenPTPTypeSelectionDialog}
          setPTPType={setPTPType}
          setOpenPointToPointBillDialog={setOpenPointToPointBillDialog}
          setOpenPointToPointChallanDialog={setOpenPointToPointChallanDialog}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      ) : null}

      {selectedItem && openLedgerSelectionDialog ? (
        <Ledger
          item={selectedItem}
          openLedgerSelectionDialog={openLedgerSelectionDialog}
          setOpenLedgerSelectionDialog={setOpenLedgerSelectionDialog}
          setOpenLedgerDialog={setOpenLedgerDialog}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          ledgerType={ledgerType}
          setLedgerType={setLedgerType}
        />
      ) : null}
      {/* Export Debtors/Creditors Date Selection Dialog */}
      <Dialog
        open={openExportDateDialog}
        onClose={() => {
          if (!isExportingDebtors && !isExportingCreditors) {
            setOpenExportDateDialog(false);
          }
        }}
        aria-labelledby="export-date-dialog-title"
      >
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  {exportMode === "creditors" ? "Export Creditors" : "Export Debtors"} - Date Range
                </h4>
              </CardHeader>
              <CardBody>
                <MuiPickersUtilsProvider utils={DateUtils}>
                  <GridContainer>
                    <GridItem xs={12}>
                      <DatePicker
                        label="Start Date (optional)"
                        fullWidth
                        value={exportStartDate}
                        onChange={(date) => setExportStartDate(date)}
                        format="DD/MM/YYYY"
                      />
                    </GridItem>
                    <GridItem xs={12} style={{ marginTop: 20 }}>
                      <DatePicker
                        label="End Date (optional)"
                        fullWidth
                        value={exportEndDate}
                        onChange={(date) => setExportEndDate(date)}
                        format="DD/MM/YYYY"
                      />
                    </GridItem>
                    <GridItem xs={12} style={{ marginTop: 10 }}>
                      <Box style={{ color: "#666", fontSize: 12 }}>
                        Leave both dates empty for all-time export. When set, export uses this range.
                      </Box>
                    </GridItem>
                  </GridContainer>
                </MuiPickersUtilsProvider>
              </CardBody>
              <CardFooter style={{ justifyContent: "center" }}>
                <Button
                  color="transparent"
                  onClick={() => {
                    if (!isExportingDebtors && !isExportingCreditors) {
                      setOpenExportDateDialog(false);
                    }
                  }}
                  disabled={isExportingDebtors || isExportingCreditors}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={async () => {
                    // Close dialog first, then trigger export with current dates
                    setOpenExportDateDialog(false);
                    const start = exportStartDate;
                    const end = exportEndDate;
                    if (exportMode === "debtors") {
                      await handleExportDebtors(start, end);
                    } else if (exportMode === "creditors") {
                      await handleExportCreditors(start, end);
                    }
                  }}
                  disabled={isExportingDebtors || isExportingCreditors}
                >
                  {isExportingDebtors || isExportingCreditors ? "Exporting..." : "Export"}
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </Dialog>
      <RoundOffTypeSelectionDialog />

      {/* Bulk Challan Generation Dialog */}
      <Dialog
        open={openBulkChallanDialog}
        onClose={() => !isGenerating && setOpenBulkChallanDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Bulk P2P Challan Generation</DialogTitle>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} style={{ marginBottom: 8 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bulkChallanMode === "manual"}
                    onChange={() => {
                      setBulkChallanMode("manual");
                      setSelectedAccs([]);
                    }}
                    color="primary"
                  />
                }
                label="Select manually"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bulkChallanMode === "preselected"}
                    onChange={() => {
                      setBulkChallanMode("preselected");
                      setSelectedAccs(bulkPrintEligibleNames);
                    }}
                    color="primary"
                  />
                }
                label="Generate pre selected"
              />
              {bulkChallanMode === "preselected" ? (
                <Box style={{ color: "#666", fontSize: 12, marginTop: 8 }}>
                  Pre selected: {bulkPrintEligibleNames.length} company(ies) with <b>printBulk</b>{" "}
                  enabled.
                </Box>
              ) : null}
            </GridItem>
            <GridItem xs={12}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                id="company-names"
                options={bulkChallanMode === "preselected" ? bulkPrintEligibleNames : allCompanyNames}
                value={selectedAccs}
                loading={bulkModalLoading}
                onChange={(event, value) => {
                  setSelectedAccs(value);
                }}
                onInputChange={(event, newInputValue) => {
                  if (bulkChallanMode === "preselected") return;
                  const searchValue = newInputValue || "";
                  setBulkModalSearchTerm(searchValue);

                  if (bulkSearchTimeoutRef.current) {
                    clearTimeout(bulkSearchTimeoutRef.current);
                  }

                  bulkSearchTimeoutRef.current = setTimeout(() => {
                    _getBulkModalAccounts(searchValue);
                  }, 300);
                }}
                inputValue={bulkChallanMode === "preselected" ? "" : bulkModalSearchTerm}
                getOptionLabel={(option) => option}
                filterOptions={(options, state) => {
                  const inputValue = state.inputValue.toLowerCase();
                  return options.filter(option =>
                    option.toLowerCase().includes(inputValue)
                  );
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Company Names (Type to search)"
                    helperText={
                      bulkChallanMode === "preselected"
                        ? "Pre selected list is based on accounts with printBulk enabled."
                        : "Type to search for accounts. Results are loaded from server."
                    }
                  />
                )}
                style={{ width: "100%" }}
              />
            </GridItem>

            <GridItem xs={12} style={{ marginTop: "20px" }}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <GridItem xs={12} sm={6} style={{ display: "inline-block", marginRight: "10px" }}>
                  <DatePicker
                    label="Start Date"
                    fullWidth
                    value={startDate}
                    onChange={setStartDate}
                    disabled={isGenerating}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} style={{ display: "inline-block" }}>
                  <DatePicker
                    label="End Date"
                    fullWidth
                    value={endDate}
                    onChange={setEndDate}
                    disabled={isGenerating}
                  />
                </GridItem>
              </MuiPickersUtilsProvider>
            </GridItem>
            <GridItem xs={12} sm={6} style={{ marginTop: "16px" }}>
              <TextField
                label="Packing charges (optional)"
                type="number"
                fullWidth
                value={bulkPackingCharge}
                onChange={(e) => setBulkPackingCharge(e.target.value)}
                disabled={isGenerating}
                inputProps={{ min: 0, step: 1 }}
                helperText="Amount in INR added once per company to the challan total"
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter style={{ justifyContent: "flex-end", padding: "20px" }}>
          <Button
            color="secondary"
            onClick={() => setOpenBulkChallanDialog(false)}
            disabled={isGenerating}
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleBulkChallanGenerate}
            disabled={isGenerating || selectedAccs.length === 0}
          >
            {isGenerating ? "Generating..." : "Generate PDFs"}
          </Button>
        </CardFooter>
      </Dialog>

      {/* Bulk Ledger Generation Dialog */}
      <Dialog
        open={openBulkLedgerDialog}
        onClose={() => !isGeneratingLedger && setOpenBulkLedgerDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Bulk Ledger Generation</DialogTitle>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                id="bulk-ledger-company-names"
                options={allCompanyNames}
                value={selectedLedgerAccs}
                loading={bulkModalLoading}
                onChange={(event, value) => setSelectedLedgerAccs(value)}
                disabled={bulkLedgerDownloadMode === "preselected"}
                onInputChange={(event, newInputValue) => {
                  if (bulkLedgerDownloadMode === "preselected") return;
                  const searchValue = newInputValue || "";
                  setBulkModalSearchTerm(searchValue);
                  if (bulkSearchTimeoutRef.current) {
                    clearTimeout(bulkSearchTimeoutRef.current);
                  }
                  bulkSearchTimeoutRef.current = setTimeout(() => {
                    _getBulkModalAccounts(searchValue);
                  }, 300);
                }}
                inputValue={bulkModalSearchTerm}
                getOptionLabel={(option) => option}
                filterOptions={(options, state) => {
                  const inputValue = state.inputValue.toLowerCase();
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue)
                  );
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Company Names (Type to search)"
                    helperText="Type to search for accounts. Use the radio below to auto-select all pre-selected parties."
                  />
                )}
                style={{ width: "100%" }}
              />
            </GridItem>
            <GridItem xs={12} style={{ marginTop: "12px" }}>
              <RadioGroup
                row
                value={bulkLedgerDownloadMode}
                onChange={(e) => setBulkLedgerDownloadMode(e.target.value)}
              >
                <FormControlLabel value="manual" control={<Radio />} label="Select manually" />
                <FormControlLabel
                  value="preselected"
                  control={<Radio />}
                  label="Download all pre selected"
                />
              </RadioGroup>
              {bulkLedgerDownloadMode === "preselected" ? (
                <Box style={{ color: "#666", fontSize: 12, marginTop: 4 }}>
                  Selected: {bulkPrintEligibleNames.length} account(s) with <b>printBulk</b> enabled.
                </Box>
              ) : null}
            </GridItem>

            <GridItem xs={12} style={{ marginTop: "20px" }}>
              <FormControl fullWidth style={{ minWidth: 120 }}>
                <InputLabel>Ledger Type</InputLabel>
                <Select
                  value={ledgerType}
                  onChange={(e) => setLedgerType(e.target.value)}
                  label="Ledger Type"
                  disabled={isGeneratingLedger}
                >
                  <MenuItem value="Challan">Challan</MenuItem>
                  <MenuItem value="Bill">Bill</MenuItem>
                </Select>
              </FormControl>
            </GridItem>

            <GridItem xs={12} style={{ marginTop: "20px" }}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <GridItem xs={12} sm={6} style={{ display: "inline-block", marginRight: "10px" }}>
                  <DatePicker
                    label="Start Date"
                    fullWidth
                    value={startDate}
                    onChange={setStartDate}
                    disabled={isGeneratingLedger}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} style={{ display: "inline-block" }}>
                  <DatePicker
                    label="End Date"
                    fullWidth
                    value={endDate}
                    onChange={setEndDate}
                    disabled={isGeneratingLedger}
                  />
                </GridItem>
              </MuiPickersUtilsProvider>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter style={{ justifyContent: "flex-end", padding: "20px" }}>
          <Button
            color="secondary"
            onClick={() => setOpenBulkLedgerDialog(false)}
            disabled={isGeneratingLedger}
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleBulkLedgerGenerate}
            disabled={
              isGeneratingLedger ||
              (bulkLedgerDownloadMode === "preselected"
                ? bulkPrintEligibleNames.length === 0
                : selectedLedgerAccs.length === 0)
            }
          >
            {isGeneratingLedger ? "Generating..." : "Generate PDFs"}
          </Button>
        </CardFooter>
      </Dialog>

      {/* Bulk Bill Print Dialog (download already-generated bills) */}
      <Dialog
        open={openBulkBillPrintDialog}
        onClose={() => !isDownloadingBills && setOpenBulkBillPrintDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Bulk Bill Print</DialogTitle>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} style={{ marginBottom: 8 }}>
              <Box display="flex" gap={2} flexWrap="wrap">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bulkBillPrintMode === "manual"}
                      onChange={() => {
                        setBulkBillPrintMode("manual");
                        setSelectedBillPrintAccs([]);
                      }}
                      color="primary"
                    />
                  }
                  label="Select manually"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={bulkBillPrintMode === "preselected"}
                      onChange={() => {
                        setBulkBillPrintMode("preselected");
                        setSelectedBillPrintAccs(bulkPrintEligibleNames);
                      }}
                      color="primary"
                    />
                  }
                  label="Generate pre selected"
                />
                {bulkBillPrintMode === "preselected" ? (
                  <Box style={{ color: "#666", fontSize: 12, marginTop: 8 }}>
                    Pre selected: {bulkPrintEligibleNames.length} company(ies) with <b>printBulk</b> enabled.
                  </Box>
                ) : null}
              </Box>
            </GridItem>

            <GridItem xs={12}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                id="bulk-bill-print-company-names"
                options={bulkPrintEligibleNames}
                value={selectedBillPrintAccs}
                loading={bulkModalLoading}
                onChange={(event, value) => setSelectedBillPrintAccs(value)}
                getOptionLabel={(option) => option}
                filterOptions={(options, state) => {
                  const inputValue = (state.inputValue || "").toLowerCase();
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue)
                  );
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Company Names"
                    helperText="Only companies with printBulk enabled are shown. In 'Generate pre selected' mode you can unselect any."
                  />
                )}
                style={{ width: "100%" }}
              />
            </GridItem>

            <GridItem xs={12} style={{ marginTop: "20px" }}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <GridItem xs={12} sm={6} style={{ display: "inline-block", marginRight: "10px" }}>
                  <DatePicker
                    label="Start Date"
                    fullWidth
                    value={startDate}
                    onChange={setStartDate}
                    disabled={isDownloadingBills}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} style={{ display: "inline-block" }}>
                  <DatePicker
                    label="End Date"
                    fullWidth
                    value={endDate}
                    onChange={setEndDate}
                    disabled={isDownloadingBills}
                  />
                </GridItem>
              </MuiPickersUtilsProvider>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter style={{ justifyContent: "flex-end", padding: "20px" }}>
          <Button
            color="secondary"
            onClick={() => setOpenBulkBillPrintDialog(false)}
            disabled={isDownloadingBills}
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleBulkBillPrintDownload}
            disabled={isDownloadingBills || selectedBillPrintAccs.length === 0}
          >
            {isDownloadingBills ? "Preparing ZIP..." : "Download ZIP"}
          </Button>
        </CardFooter>
      </Dialog>
    </GridContainer>
  );
}
